import { ChangeDetectionStrategy, Component, Injector, ViewChild } from '@angular/core';
import { WidgetBase } from '../../widget-content/base/widget-base';
import { WidgetContentNewsFeedComponent } from '../../widget-content/news-feed/news-feed.component';

@Component({
    selector: 'fi-widget-news-feed',
    templateUrl: './news-feed.component.html',
    styleUrls: ['./news-feed.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-widget-news-feed' },
    standalone: false,
})
export class WidgetNewsFeedComponent extends WidgetBase {
    constructor(injector: Injector) {
        super(injector);
    }

    @ViewChild(WidgetContentNewsFeedComponent, { static: false }) newsFeedContent: WidgetContentNewsFeedComponent;

    get isEmpty$() {
        return this.newsFeedContent.isEmpty$;
    }
}
